import PaymentsEdit from '@/components/oa/payform/PaymentsEdit';//付款申请单
import ReimburseEdit from '@/components/oa/payform/ReimburseEdit';//费用报销单
import OrderBackEdit from '@/components/oa/payform/OrderBackEdit';//费用报销单


export default {
  install: function (Vue, options) {
    Vue.component("PaymentsEdit", PaymentsEdit)
    Vue.component("ReimburseEdit", ReimburseEdit)
    Vue.component("OrderBackEdit", OrderBackEdit)
  }
}



// WEBPACK FOOTER //
// ./src/plugin/workflowcomponents.js